import { gql } from '@apollo/client';

export const readPartnerSettingsConfigurationSchemaQuery = gql`
  query readPartnerSettingsConfigurationSchema($integrationType: String!) {
    Management {
      settingsConfigurationSchema(integrationType: $integrationType) {
        key
        label
        type
        secret
        required
        readOnly
        placeholder
        prefix
        defaultValue
        hideOnCreate
        additionalProperties
        selectItems {
          label
          value
        }
      }
    }
  }
`;
